import { z } from "zod"
import { AddressSchema } from "@pages/makeEvent/steps-components/address-component/schema.ts"
import DateSchema from "@pages/makeEvent/steps-components/eventDate-component/schema.ts"
import descriptionSchema from "@pages/makeEvent/steps-components/eventDescription-component/schema.ts"
import NameSchema from "@pages/makeEvent/steps-components/eventName-component/schema.ts"

const SchemaForFormik = z.object({
	event_address: AddressSchema,
	...NameSchema.shape,
  ...DateSchema.shape,
	...descriptionSchema.shape
});


export default SchemaForFormik